import { render, staticRenderFns } from "./CalcTitle.vue?vue&type=template&id=196f9cb6"
import script from "./CalcTitle.vue?vue&type=script&lang=js"
export * from "./CalcTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports